// OS TEXTOS DA EQUIPE (QA da Equipe, 26/09/2026). Estavam no componente, em vozes diferentes
// ("Erro ao carregar equipe", "Membro atualizado") e com travessão na explicação do acesso. A voz é
// a dos outros módulos: "Não deu para…", sem travessão e sem emoji.

export const TEXTOS_DA_EQUIPE = {
  'aba.todos': 'Todos',
  'aba.ativos': 'Ativos',
  'aba.pendentes': 'Convites pendentes',
  'vazio.titulo': 'Sua equipe começa aqui',
  'vazio.texto': 'Convide quem trabalha com você pelo e-mail. A pessoa entra no perfil assim que aceitar.',
  'nada.busca': 'Ninguém com esse nome nesta aba.',
  'nada.pendentes': 'Nenhum convite esperando resposta.',
  'nada.ativos': 'Ninguém ativo ainda.',
  'ordem.titulo': 'Ordenar a equipe',
  'ordem.subtitulo': 'Escolha a ordem da lista',
  'ordem.rotulo': 'Ordenar por',
  'ordem.recentes': 'Convidados mais recentes',
  'ordem.nome': 'Nome (A a Z)',
  'status.active': 'Ativo',
  'status.pending': 'Convite pendente',
  'status.rejected': 'Recusou',
  'acesso.edita': 'Edita o conteúdo',
  'acesso.leitura': 'Somente leitura',
  'titular': 'Titular',
  'titular.apoio': 'Dono do perfil',
  'convidar': 'Convidar membro',
  'convidar.titulo': 'Convidar para a equipe',
  'convidar.subtitulo': 'A pessoa recebe um e-mail e entra no perfil quando aceitar.',
  'convidar.enviar': 'Enviar convite',
  'membro.kicker': 'Equipe',
  'membro.subtitulo': 'Os dados desta pessoa e o que ela pode fazer no perfil.',
  'membro.convidado_em': 'Convidado em {data}',
  'campo.nome': 'Nome',
  'campo.nome.placeholder': 'Como a pessoa se chama',
  'campo.email': 'E-mail',
  'campo.email.placeholder': 'nome@exemplo.com',
  // O músico é membro da equipe desde 01/11/2026 (o Elenco virou a Equipe).
  'campo.funcao': 'Função',
  'campo.funcao.placeholder': 'Escolha o cargo ou escreva',
  'campo.funcao.apoio': 'Escolha o cargo da lista ou escreva: o acesso aparece logo abaixo, já marcado para ele.',
  'campo.telefone': 'Telefone',
  // O convite que nasce na Formação ou no show: o músico acompanha os shows, a agenda e as músicas.
  'musico.titulo': 'Convidar para a equipe',
  'musico.subtitulo': 'A pessoa recebe um e-mail para entrar no perfil e acompanhar os shows. Ela vai ver o Cronograma dos shows em que estiver escalada, a Agenda e as Músicas, sem editar; você muda isso na Equipe.',
  'musico.so_titular': 'Só o titular do perfil convida para a equipe.',
  'acesso.titulo': 'O que esta pessoa pode fazer',
  // O acesso por módulo (03/10/2026): o titular escolhe Sem acesso, Ver ou Editar em cada um.
  'acesso.por_modulo': 'Em cada página: não entra, só vê ou edita. O Início fica aberto a toda a equipe; convidar ou remover pessoas, excluir o perfil e a cobrança são só do titular.',
  'acesso.modelo': 'Acesso',
  'acesso.personalizar': 'Personalizar página por página',
  'acesso.esconder': 'Esconder as páginas',
  'acesso.legenda': 'Acesso por módulo',
  // Sem travessão (voz da marca). E a lista inteira: o convidado vê CRM, Shows e Arquivos também
  // (decisão do Lucas, 25/09), e o texto só falava de músicas, agenda e planejamento.
  'acesso.texto': 'Ver e editar o conteúdo do perfil: músicas, agenda, plano, CRM, shows e arquivos. Convidar ou remover pessoas, excluir o perfil e ver a cobrança continuam só com o titular.',
  'menu.editar': 'Editar',
  'menu.ver': 'Ver',
  'menu.reenviar': 'Reenviar convite',
  'menu.remover': 'Remover da equipe',
  'menu.cancelar_convite': 'Cancelar convite',
  'menu.convidar_de_novo': 'Convidar de novo',
  'remover.pergunta': 'Remover {nome} da equipe?',
  'remover.descricao': 'A pessoa perde o acesso ao perfil. Os compromissos que eram dela ficam sem responsável.',
  'cancelar.pergunta': 'Cancelar o convite de {nome}?',
  'cancelar.descricao': 'O link do e-mail deixa de valer.',
} as const;

export const AVISOS_DA_EQUIPE = {
  erro_carregar: 'Não deu para carregar a equipe.',
  erro_convidar: 'Não deu para enviar o convite.',
  erro_salvar: 'Não deu para salvar.',
  erro_remover: 'Não deu para remover.',
  erro_reenviar: 'Não deu para reenviar o convite.',
  aviso_email_invalido: 'Esse e-mail não parece certo.',
  aviso_ja_na_equipe: 'Essa pessoa já está na equipe.',
  aviso_ja_convidada: 'Essa pessoa já tem um convite esperando resposta.',
  aviso_e_voce: 'Esse é o e-mail do titular do perfil.',
  aviso_convite_enviado: 'Convite enviado.',
  aviso_convite_reenviado: 'Convite reenviado.',
  aviso_email_nao_saiu: 'O convite foi criado, mas o e-mail não saiu. Tente reenviar pelo menu.',
  aviso_espere_reenviar: 'O convite acabou de sair. Espere uns minutos para reenviar.',
  aviso_salvo: 'Salvo.',
  aviso_removido: 'Removido da equipe.',
  aviso_convite_cancelado: 'Convite cancelado.',
  aviso_saiu_da_equipe: 'Você não faz mais parte da equipe deste perfil.',
  aviso_acesso_mudou: 'O titular mudou o que você pode ver e editar neste perfil.',
} as const;

// Os convites que a pessoa RECEBEU, no topo de "Seus perfis" (`PendingInvites`).
export const TEXTOS_DO_CONVITE_RECEBIDO = {
  titulo: 'Convites para equipes',
  apoio: 'Você foi convidado para a equipe',
  artista: 'Artista',
  aceitar: 'Aceitar',
  recusar: 'Recusar',
  'recusar.pergunta': 'Recusar o convite de {nome}?',
  'recusar.descricao': 'Você só entra nesta equipe se o titular convidar de novo.',
} as const;

export const AVISOS_DO_CONVITE_RECEBIDO = {
  aviso_entrou: 'Você entrou na equipe de {nome}.',
  aviso_recusado: 'Convite recusado.',
  erro_aceitar: 'Não deu para aceitar o convite.',
  erro_recusar: 'Não deu para recusar o convite.',
  erro_carregar: 'Não deu para ver seus convites.',
} as const;
